/**
 * Recharts can't read CSS variables, so chart strokes/fills are resolved to the
 * same values the design tokens declare in index.css. Kept in a `.ts` (not the
 * chart `.tsx`) so the literal colors live beside the token comment, mirroring
 * the renewals dashboard's CHART_COLORS. Keep in lockstep with index.css.
 */
export const PROPOSAL_CHART_COLORS = {
  brand: "#0994f2", // --cinch-brand
  gridLine: "hsl(0 0% 88%)",
  marker: "hsl(38 92% 50%)", // --status-warning — a promo rolling off
  term: "#2851d0", // --cinch-power — term / renewal boundary
} as const;
